module.exports = __webpack_public_path__ + "img/MTABAPPABP.5ec04477.svg";